module.exports = __webpack_public_path__ + "img/brushPreview.08c3b19e.jpg";